module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA3ElEQVRYw+3WuxHCMBAEUJVA7tjQirtyacopwRn+0MYSwDCcrM/pdGIYrM0ceF/iHZ8xLT8UdLDoa9ZPANZqBCyeqUWgx9qIAxAYsOAzbwInXOHPgoEPzLvXOcTstIxhwBcGQevpcxpgELQ+H0gStF4CJAhaLwOiBK2XAhGC1suBMDGGv6o8gLeLIiB7F/lA1i5kAHsXcoC1izIguYtyILoLHSBI6AEBQhPwErqAh9AGdoQ+4BA5P30RwT9bOLnh7hLa19TlL4gztu8R1tTJ62ye0BlTj7AV61sOmwclqjgfXSGrSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/icon-camera-off.png
// module id = 1342
// module chunks = 0